import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as piDataActions from '../actions/pi-data.action';
import { mergeMap, map, catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { PiDataService } from '../../services/pi-data.service';

@Injectable()
export class PiDataEffects {
  constructor(
    private actions$: Actions,
    private piDataService: PiDataService,
  ) {}

  loadPiData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(piDataActions.loadLatestPiData),
      mergeMap((action) => {
        return this.piDataService
          .GetLatestPiDatasEquipement(action.equipementId)
          .pipe(
            map((piData) => piDataActions.loadLatestPiDataSuccess({ piData })),
            catchError((error) =>
              of(piDataActions.loadLatestPiDataFailure({ error })),
            ),
          );
      }),
    ),
  );

  validatePiPoint$ = createEffect(() =>
    this.actions$.pipe(
      ofType(piDataActions.validatePiPoint),
      switchMap(({ searchTerm }) => {
        const upperCaseSearchTerm = searchTerm.toUpperCase();
        return this.piDataService.GetPiPointForTag(upperCaseSearchTerm).pipe(
          map((piPoint) =>
            piDataActions.validatePiPointSuccess({
              searchTerm: upperCaseSearchTerm,
              isValid:
                piPoint &&
                piPoint.tag?.length > 0 &&
                piPoint.webId?.length > 0 &&
                piPoint.server?.length > 0,
            }),
          ),
          catchError((error) =>
            of(
              piDataActions.validatePiPointFailure({
                searchTerm: upperCaseSearchTerm,
                error,
              }),
            ),
          ),
        );
      }),
    ),
  );

  loadPiPointsByRuleId$ = createEffect(() =>
    this.actions$.pipe(
      ofType(piDataActions.loadPiPointsByRuleId),
      switchMap(({ ruleUid }) => {
        return this.piDataService.GetPiPointsTagsByRuleId(ruleUid).pipe(
          map((piPoints) =>
            piDataActions.loadPiPointsByRuleIdSuccess({ piPoints }),
          ),
          catchError((error) =>
            of(piDataActions.loadPiPointsByRuleIdFailure({ error })),
          ),
        );
      }),
    ),
  );
}
